import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://changemanagement-backend-ahfre3hvgcerbrgp.canadacentral-01.azurewebsites.net/api'
    : 'http://localhost:5000/api'
  );

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000 // Increased from 30s to 60s for AI generation
});

// Request interceptor to add auth token and handle Content-Type properly
apiClient.interceptors.request.use(request => {
  const token = localStorage.getItem('access_token');
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Only set Content-Type to JSON if there's data and it's not FormData
  if (request.data && !(request.data instanceof FormData)) {
    request.headers['Content-Type'] = 'application/json';
  }
  
  // Override timeout for AI generation endpoints
  if (request.url && request.url.includes('generate-communication')) {
    request.timeout = 90000; // 90 seconds for AI generation specifically
    console.log('🤖 Extended timeout for AI generation request');
  }
  
  return request;
});

// Response interceptor for auth errors and better error handling
apiClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    if (error.response?.status === 401) {
      // Don't redirect to login if we're on a public page
      const currentPath = window.location.pathname;
      
      // List of public pages that don't require authentication
      const publicPages = [
        '/signin',
        '/register',
        '/reset-password',
        '/set-password',
        '/verify-email',
        '/guest/assessment/',
        '/'  // Homepage
      ];
      
      // Check if current page is public
      const isPublicPage = publicPages.some(page => currentPath.includes(page));
      
      if (!isPublicPage) {
        // Save the user's email before clearing session
        const currentUser = localStorage.getItem('ezocmUser');
        if (currentUser) {
          try {
            const userData = JSON.parse(currentUser);
            if (userData.email) {
              localStorage.setItem('lastUserEmail', userData.email);
            }
          } catch (e) {
            console.error('Error parsing user data:', e);
          }
        }
        
        // Set session expired flag
        localStorage.setItem('sessionExpired', 'true');
        
        // Clear auth data
        localStorage.removeItem('access_token');
        localStorage.removeItem('ezocmUser');
        
        // Redirect to signin
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
